import Auth from "./Auth";
import POS from "./POS";
import Bar from "./Bar";
import Kitchen from "./Kitchen";
import Waiter from "./Waiter";
import Dashboard from "./Dashboard";
import CakeRoom from "./CakeRoom";
import TableOrder from "./Components/TableOrder";
export default {
  Auth,
  POS,
  Kitchen,
  Waiter,
  Dashboard,
  Bar,
  TableOrder,
  CakeRoom,
};
